var map = {
	"./40.svg": "fad6",
	"./banner-bg.webp": "c95a",
	"./binom-d.png": "533f",
	"./binom.webp": "dc3c",
	"./case-en.webp": "b7c2",
	"./case-ru.webp": "633c",
	"./icon-1.svg": "3c3b",
	"./icon-2.svg": "5ecc",
	"./icon-3.svg": "5caf",
	"./icon-4.svg": "57db",
	"./keitaro.svg": "3a70",
	"./play.svg": "d7da",
	"./settings.svg": "0b12",
	"./video-thumb-1.jpg": "a112",
	"./video-thumb-1.webp": "561b",
	"./video-thumb-2.jpg": "f9fa",
	"./video-thumb-2.webp": "59c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9fb";